import { render, staticRenderFns } from "./tag-checkbox.vue?vue&type=template&id=bdccee62&scoped=true"
import script from "./tag-checkbox.vue?vue&type=script&lang=js"
export * from "./tag-checkbox.vue?vue&type=script&lang=js"
import style0 from "./tag-checkbox.vue?vue&type=style&index=0&id=bdccee62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdccee62",
  null
  
)

export default component.exports